<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ establishment.id ? "Editar" : "Novo" }} Estabelecimento
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>
                        <span class="required">*</span> Buscar endereço
                        (Google):
                      </label>
                      <GmapAutocomplete
                        ref="autocomplete"
                        class="form-control"
                        placeholder="Digite o endereço para localizar automaticamente..."
                        @place_changed="onPlaceChanged"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-12 mb-3">
                      <GmapMap
                        ref="mapRef"
                        :center="mapCenter"
                        :zoom="mapZoom"
                        map-type-id="roadmap"
                        style="width: 100%; height: 300px"
                        @click="onMapClick"
                      >
                        <GmapMarker
                          v-if="establishment.latitude && establishment.longitude"
                          :position="{
                            lat: parseFloat(establishment.latitude),
                            lng: parseFloat(establishment.longitude),
                          }"
                          :draggable="true"
                          @dragend="onMarkerDrag"
                        />
                      </GmapMap>
                      <small class="text-muted"
                        >Clique no mapa ou arraste o marcador para ajustar a
                        localização exata.</small
                      >
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> Tipo de
                        Estabelecimento:
                      </label>
                      <v-select
                        :options="type_establishments"
                        :reduce="
                          (type_establishments) => type_establishments.id
                        "
                        :label="'establishment_type_name'"
                        v-model="establishment.type_establishment_id"
                        v-on:input="onTypeEstablishmentChange"
                        class="vselect"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.establishment_name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label> Nome Fantasia: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.trade_name"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label> CNPJ: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.cnpj"
                        v-mask="'99.999.999/9999-99'"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label> E-mail: </label>
                      <input
                        autocomplete="new-password"
                        type="email"
                        class="form-control"
                        v-model="establishment.email"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label> Telefone: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.telephone"
                        v-mask="'(99) 9999-9999'"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label> Celular: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.cellphone"
                        v-mask="'(99) 99999-9999'"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-2">
                      <label>
                        <span class="required">*</span> CEP:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.zip_code"
                        v-mask="'99999-999'"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.address"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>
                        <span class="required">*</span> Número:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.number"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label> Complemento: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.complement"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Bairro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="establishment.neighborhood"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Estado:
                      </label>
                      <v-select
                        :options="ufs"
                        :reduce="(ufs) => ufs.id"
                        :label="'name'"
                        v-model="establishment.state_id"
                        v-on:input="getCities"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Cidade:
                      </label>
                      <v-select
                        :options="cities"
                        :reduce="(cities) => cities.id"
                        :label="'name'"
                        v-model="establishment.city_id"
                        class="vselect"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="establishment.status"
                        class="form-control"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Tipos de Ocorrência atendidos:</label>
                      <v-select
                        :options="availableDispatchTypes"
                        :reduce="(t) => t.id"
                        label="name"
                        multiple
                        v-model="establishment.dispatch_type_ids"
                        class="vselect"
                        placeholder="Nenhum"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Motivos atendidos:</label>
                      <v-select
                        :options="availableDispatchReasons"
                        :reduce="(r) => r.id"
                        label="label"
                        multiple
                        v-model="establishment.dispatch_reason_ids"
                        class="vselect"
                        placeholder="Nenhum"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Linhas de Cuidado atendidas:</label>
                      <v-select
                        :options="availableCareLines"
                        :reduce="(c) => c.id"
                        label="name"
                        multiple
                        v-model="establishment.care_line_ids"
                        class="vselect"
                        placeholder="Nenhuma"
                      />
                    </div>
                    <div class="col-md-12">
                      <small class="text-muted">
                        Na tela de Definir Destino, este estabelecimento só aparece nos
                        filtros pelo que estiver marcado aqui. Em branco, ele aparece só
                        na busca sem filtro.
                      </small>
                    </div>
                  </div>

                  <!-- Campos dinâmicos do Tipo de Estabelecimento -->
                  <div v-if="fieldSchema.length" class="card mt-2">
                    <div class="card-header py-2">
                      <span class="font-weight-bold"
                        >Informações específicas do tipo</span
                      >
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div
                          v-for="field in fieldSchema"
                          :key="field.key"
                          :class="['form-group', field.col || 'col-md-6']"
                        >
                          <label>
                            <span v-if="field.required" class="required"
                              >*</span
                            >
                            {{ field.label }}:
                          </label>
                          <input
                            v-if="field.type === 'text'"
                            v-model="establishment.metadata[field.key]"
                            class="form-control"
                            type="text"
                          />
                          <input
                            v-else-if="field.type === 'number'"
                            v-model="establishment.metadata[field.key]"
                            class="form-control"
                            type="number"
                          />
                          <textarea
                            v-else-if="field.type === 'textarea'"
                            v-model="establishment.metadata[field.key]"
                            class="form-control"
                            rows="3"
                          />
                          <select
                            v-else-if="field.type === 'select'"
                            v-model="establishment.metadata[field.key]"
                            class="form-control"
                          >
                            <option value="">Selecione</option>
                            <option
                              v-for="opt in field.options"
                              :key="opt"
                              :value="opt"
                            >
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/establishments" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      establishment: {
        establishment_name: "",
        trade_name: "",
        cnpj: "",
        email: "",
        telephone: "",
        cellphone: "",
        zip_code: "",
        address: "",
        number: "",
        complement: "",
        neighborhood: "",
        city_id: "",
        state_id: "",
        type_establishment_id: "",
        latitude: null,
        longitude: null,
        status: 1,
        metadata: {},
        dispatch_type_ids: [],
        dispatch_reason_ids: [],
        care_line_ids: [],
      },
      cities: [],
      ufs: [],
      type_establishments: [],
      fieldSchema: [],
      mapCenter: { lat: -15.77972, lng: -47.92972 },
      mapZoom: 13,
      // Tipos, Motivos e Linhas de Cuidado que este estabelecimento atende —
      // usado pra filtrar a lista de destino na tela de Definir Destino.
      availableDispatchTypes: [],
      availableDispatchReasons: [],
      availableCareLines: [],
    };
  },
  computed: {},
  methods: {
    onPlaceChanged(place) {
      if (!place || !place.geometry) return;

      const loc = place.geometry.location;
      this.establishment.latitude = loc.lat();
      this.establishment.longitude = loc.lng();
      this.mapCenter = { lat: loc.lat(), lng: loc.lng() };
      this.mapZoom = 17;

      const components = place.address_components || [];
      const get = (type) => {
        const c = components.find((c) => c.types.includes(type));
        return c ? c.long_name : "";
      };
      const getShort = (type) => {
        const c = components.find((c) => c.types.includes(type));
        return c ? c.short_name : "";
      };

      this.establishment.address = get("route") || "";
      this.establishment.number = get("street_number") || "";
      this.establishment.neighborhood =
        get("sublocality_level_1") || get("sublocality") || get("neighborhood");
      this.establishment.zip_code = get("postal_code") || "";

      const cityName = get("administrative_area_level_2") || get("locality");
      const stateCode = getShort("administrative_area_level_1");

      if (stateCode) {
        this.resolveLocation(stateCode, cityName);
      }
    },

    onMapClick(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.establishment.latitude = lat;
      this.establishment.longitude = lng;

      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const place = results[0];
            const input = this.$refs.autocomplete;
            if (input && input.$refs && input.$refs.input) {
              input.$refs.input.value = place.formatted_address;
            }
            this.onPlaceChanged(place);
          }
        });
      }
    },

    onMarkerDrag(event) {
      this.establishment.latitude = event.latLng.lat();
      this.establishment.longitude = event.latLng.lng();
    },

    resolveLocation: function (stateCode, cityName) {
      const self = this;
      const api = self.$store.state.api + "ufs?code=" + stateCode + "&paginated=false";

      axios
        .get(api)
        .then((response) => {
          const uf = response.data.data[0];
          if (!uf) return;

          self.establishment.state_id = uf.id;

          self.getCities().then(() => {
            const match = self.cities.find(
              (c) => c.name.toLowerCase() === (cityName || "").toLowerCase()
            );
            if (match) {
              self.establishment.city_id = match.id;
            }
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    onTypeEstablishmentChange: function (typeId) {
      const type = this.type_establishments.find((t) => t.id === typeId);
      this.fieldSchema = type && type.field_schema ? type.field_schema : [];

      const meta = this.establishment.metadata || {};
      this.fieldSchema.forEach((f) => {
        if (!(f.key in meta)) meta[f.key] = "";
      });
      this.establishment.metadata = meta;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "establishments";

      if (self.establishment.id) {
        self.establishment._method = "PUT";
        api += "/" + self.establishment.id;
      }

      self.$loading(true);

      axios
        .post(api, self.establishment)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/establishments");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getTypeEstablishments: function () {
      const self = this;
      let api =
        self.$store.state.api + "establishment_types?paginated=false&status=1";

      return axios
        .get(api)
        .then((response) => {
          self.type_establishments = response.data.data;
          if (self.establishment.type_establishment_id) {
            self.onTypeEstablishmentChange(
              self.establishment.type_establishment_id
            );
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUfs: function () {
      const self = this;
      let api = self.$store.state.api + "ufs?paginated=false&status=1";

      return axios
        .get(api)
        .then((response) => {
          self.ufs = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCities: function () {
      const self = this;
      let api =
        self.$store.state.api +
        "cities?orderByAsc=name&paginated=false&status=1&uf_id=" +
        self.establishment.state_id;

      return axios
        .get(api)
        .then((response) => {
          self.cities = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEstablishment: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "establishments/" +
        id +
        "?with[]=dispatchTypes&with[]=dispatchReasons&with[]=careLines";
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          // Monta o objeto completo ANTES de atribuir a self.establishment.
          // Se a gente atribuir primeiro e só depois adicionar
          // dispatch_type_ids/etc num passo separado, essas chaves não
          // existiam no objeto no momento em que o Vue o tornou reativo — a
          // atribuição posterior muda o valor mas não dispara re-render
          // (só "aparece" depois, quando outro campo reativo força o
          // componente a re-renderizar por outro motivo).
          const data = response.data.data[0];
          if (!data.metadata) data.metadata = {};
          data.dispatch_type_ids = (data.dispatch_types || []).map((t) => t.id);
          data.dispatch_reason_ids = (data.dispatch_reasons || []).map(
            (r) => r.id
          );
          data.care_line_ids = (data.care_lines || [])
            .filter((c) => Number(c.status) === 1)
            .map((c) => c.id);
          delete data.dispatch_types;
          delete data.dispatch_reasons;
          delete data.care_lines;
          self.establishment = data;
          if (self.establishment.state_id) {
            self.getCities();
          }
          if (self.establishment.latitude && self.establishment.longitude) {
            self.mapCenter = {
              lat: parseFloat(self.establishment.latitude),
              lng: parseFloat(self.establishment.longitude),
            };
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDispatchTypesForNode: function () {
      const self = this;
      const api = self.$store.state.api + "dispatch_types/for-node";
      // Nunca confiar no current_node_id do backend pra esse tipo de tela —
      // é o $store.state.selected_node (setado pelo NodeSelector) que reflete
      // o nó que o usuário está de fato operando agora.
      const nodeId = self.$store.state.selected_node
        ? self.$store.state.selected_node.id
        : null;

      return axios
        .get(api, { params: { node_id: nodeId, with_descendants: 1 } })
        .then((response) => {
          self.availableDispatchTypes = response.data.data || [];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDispatchReasonsForNode: function () {
      const self = this;
      const api = self.$store.state.api + "dispatch_reasons/for-node";
      const nodeId = self.$store.state.selected_node
        ? self.$store.state.selected_node.id
        : null;

      return axios
        .get(api, { params: { node_id: nodeId, with_descendants: 1 } })
        .then((response) => {
          self.availableDispatchReasons = (response.data.data || []).map(
            (r) => ({
              ...r,
              label: r.dispatch_type
                ? `${r.dispatch_type.name} — ${r.name}`
                : r.name,
            })
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCareLinesForNode: function () {
      const self = this;
      const api = self.$store.state.api + "care_lines/for-node";
      const nodeId = self.$store.state.selected_node
        ? self.$store.state.selected_node.id
        : null;

      return axios
        .get(api, { params: { node_id: nodeId, with_descendants: 1, status: 1 } })
        .then((response) => {
          self.availableCareLines = response.data.data || [];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUfs();
    self.getTypeEstablishments();
    self.getDispatchTypesForNode();
    self.getDispatchReasonsForNode();
    self.getCareLinesForNode();

    let id = self.$route.params.id;
    if (id) {
      self.getEstablishment(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.required {
  color: red;
}
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
</style>
